export const PATROL_OVERDUE_EVENT = 'PatrolOverdue'

export function isPatrolOverdueEvent(event: string): boolean {
  return event === PATROL_OVERDUE_EVENT
}

export function readPatrolIdFromPayload(payload: string | null | undefined): number | null {
  if (!payload) return null
  try {
    const parsed = JSON.parse(payload) as unknown
    if (typeof parsed !== 'object' || parsed === null) return null
    const raw = (parsed as Record<string, unknown>).patrolId
    const id = typeof raw === 'string' ? Number(raw) : raw
    return typeof id === 'number' && Number.isInteger(id) && id > 0 ? id : null
  } catch {
    return null
  }
}
